import { render } from "./ErrorPage404.vue?vue&type=template&id=2bfedb62&scoped=true"
import script from "./ErrorPage404.vue?vue&type=script&lang=js"
export * from "./ErrorPage404.vue?vue&type=script&lang=js"

import "./ErrorPage404.vue?vue&type=style&index=0&id=2bfedb62&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfedb62"]])

export default __exports__